import SaleModel from "../../data/model/Sale";
import { Sale } from "@towersystems/roam-common/lib/generated-types";
import DocketTemplate from "../../data/model/DocketTemplate";
import { usePrint } from "../../print";
import { generateHTML } from "../utils";
import { useDatabase } from "@nozbe/watermelondb/react";
import { useWithAppState } from "@towersystems/roam-common-native";

export interface UsePrintDocketProps {}

export const usePrintDocket = ({}: UsePrintDocketProps = {}) => {
  const { print } = usePrint();
  const database = useDatabase();
  const {
    appState: { terminalId },
  } = useWithAppState();

  const handleOnPrintAllAutomaticDockets = async (sale: Sale | SaleModel) => {
    try {
      const docketTemplates = await database.collections
        .get<DocketTemplate>("docket_templates")
        .query()
        .fetch();

      const docketTemplatesToPrint = docketTemplates.filter(
        (docketTemplate) =>
          docketTemplate.automaticallyPrint &&
          (!docketTemplate.terminalIds?.length ||
            docketTemplate.terminalIds?.includes(terminalId))
      );
      await Promise.all(
        docketTemplatesToPrint.map(async (docketTemplate) => {
          return await handleOnPrintReceipt(sale, docketTemplate);
        })
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleOnPrintAllDockets = async (sale: Sale | SaleModel) => {
    try {
      const docketTemplates = await database.collections
        .get<DocketTemplate>("docket_templates")
        .query()
        .fetch();

      const docketTemplatesToPrint = docketTemplates.filter(
        (docketTemplate) =>
          !docketTemplate.terminalIds?.length ||
          docketTemplate.terminalIds?.includes(terminalId)
      );

      await Promise.all(
        docketTemplatesToPrint.map(async (docketTemplate) => {
          return await handleOnPrintReceipt(sale, docketTemplate);
        })
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleOnPrintReceipt = async (
    sale: Sale | SaleModel,
    docketTemplate: DocketTemplate
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (false == docketTemplate.terminalIds?.includes(terminalId)) {
          return resolve(1);
        }
        const html = await generateHTML(sale, docketTemplate, database);
        return await print(html, {
          afterPrint: async () => {
            try {
              return resolve(1);
            } catch (err) {
              return reject(err);
            }
          },
        });
      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  };

  return {
    handleOnPrintReceipt,
    handleOnPrintAllDockets,
    handleOnPrintAllAutomaticDockets,
  };
};
